import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavComponent } from './nav/nav.component';
import { MenuComponent } from './menu/menu.component';
import { IdentificateComponent } from './identificate/identificate.component';
import { JL } from 'jsnlog';
import { FooterComponent } from './components/footer/footer.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule, MatIconModule, MatListModule, MatSnackBarModule, MatInputModule, MatButtonModule  } from '@angular/material';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from '../shared/shared.module';
import { RecuperacionComponent } from './recuperacion/recuperacion.component';
import { ResetPasswordRequestComponent } from './components/reset-password-request/reset-password-request.component';
import { Title } from '@angular/platform-browser';
import { AuthorizeInterceptor } from './authorize.interceptor';
import { ScrollDirective } from '../shared/directives/scroll.directive';


@NgModule({
  imports: [
    CommonModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatSnackBarModule,
    MatInputModule,
    MatButtonModule,
    SharedModule,
    MatDialogModule
  ],
  declarations: [NavComponent, MenuComponent, IdentificateComponent, FooterComponent, RecuperacionComponent, ResetPasswordRequestComponent, ScrollDirective],
  exports: [NavComponent, IdentificateComponent, ScrollDirective],
  providers: [
    { provide: 'JSNLOG', useValue: JL },
    Title
  ]
})
export class CoreModule { }
